import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import React, { useContext } from 'react';
import { EditableInfoContainer } from '@dealstack/frontend/shared/components/EditableInfoContainer/EditableInfoContainer.tsx';
import { PersonDataContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/hooks/usePersonData.ts';
import { ConfirmDeleteDrawer } from '@dealstack/frontend/shared/components/ConfirmDeleteDrawer/ConfirmDeleteDrawer.tsx';
import { TaxInformationTile } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/components/TaxInformationSection/components/TaxInformationTile.tsx';
import { TaxInfoDrawer } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/components/TaxInfoDrawer/TaxInfoDrawer.tsx';

export const TaxInformationSection = ({
	hasEditorPermission,
}: {
	hasEditorPermission: boolean;
}) => {
	const tCapManage = useTranslationCapManage();
	const {
		taxInfo,
		deleteTaxInfo,
		setDeleteTaxInfo,
		deletePersonTaxInfo,
		deletePersonTaxInfoSuccess,
		deletePersonTaxInfoLoading,
		editTaxInfo,
		setEditTaxInfo,
		addTaxInfo,
		setAddTaxInfo,
	} = useContext(PersonDataContext);

	return (
		<>
			{taxInfo.length ? (
				<EditableInfoContainer
					title={tCapManage('basic_details.tax_info.title')}
					isEdit={false}
					hasEditorPermission={hasEditorPermission}
					gridColumns={2}
					useGrid={true}
					childrenPadding="0.5rem"
					onAdd={() => setAddTaxInfo(true)}
				>
					{taxInfo.map((t) => (
						<TaxInformationTile
							key={t.id}
							taxData={t}
							onRemove={setDeleteTaxInfo}
							onEdit={setEditTaxInfo}
							hasEditPermission={hasEditorPermission}
						/>
					))}
				</EditableInfoContainer>
			) : null}

			{hasEditorPermission && (
				<>
					<TaxInfoDrawer
						opened={addTaxInfo}
						onClose={() => setAddTaxInfo(false)}
						hasPermission={hasEditorPermission}
						taxData={null}
					/>

					<TaxInfoDrawer
						opened={!!editTaxInfo}
						onClose={() => setEditTaxInfo(null)}
						hasPermission={hasEditorPermission}
						taxData={editTaxInfo}
					/>

					<ConfirmDeleteDrawer
						opened={!!deleteTaxInfo}
						onClose={() => setDeleteTaxInfo(null)}
						title={tCapManage('delete.tax_info.drawer.title')}
						inputLabel={tCapManage('delete.tax_info.drawer.input_label')}
						inputPlaceholder={tCapManage('delete.tax_info.drawer.input_placeholder')}
						confirmDeleteText={
							deleteTaxInfo?.number ||
							deleteTaxInfo?.authority ||
							deleteTaxInfo?.countryCode ||
							'Delete Tax'
						}
						wordMismatchErrorMessage={tCapManage(
							'delete.tax_info.drawer.word_mismatch_error'
						)}
						deleteBtnText={tCapManage('delete.tax_info.drawer.confirm_delete')}
						cancelBtnText={tCapManage('delete.tax_info.drawer.cancel')}
						handleDelete={deletePersonTaxInfo}
						deleteLoading={deletePersonTaxInfoLoading}
						deleteSuccess={deletePersonTaxInfoSuccess}
					/>
				</>
			)}
		</>
	);
};
